const beneficiosInitialState = {
  beneficios: {
    estado: false,
  },
};

export default beneficiosInitialState;
